import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20lifestyle%20brand%20hero%20background%20with%20soft%20golden%20amber%20tones%2C%20elegant%20abstract%20flowing%20fabric%20textures%2C%20gentle%20gradients%20from%20warm%20cream%20to%20deep%20terracotta%2C%20artistic%20composition%20with%20organic%20curves%2C%20no%20text%2C%20clean%20sophisticated%20aesthetic%2C%20editorial%20quality%2C%20moody%20warm%20lighting&width=1800&height=900&seq=hero-bg-xb-01&orientation=landscape"
        alt="性巴克品牌形象"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="性巴克品牌形象展示"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-background-50/80 text-xs md:text-sm font-label tracking-[0.2em] uppercase mb-4 md:mb-5 animate-fade-up">
            XINGBAKE · 探索独特生活体验
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 md:mb-6">
            发现
            <span className="text-primary-400">性巴克</span>
            的<br className="md:hidden" />非凡世界
          </h1>
          <p className="text-background-50/70 text-sm md:text-lg max-w-xl mx-auto leading-relaxed mb-7 md:mb-9">
            性巴克是一个独特的品牌与文化符号，融合创新理念与卓越品质，为每一位追求不凡生活的你带来全新体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/categories"
              className="w-full sm:w-auto px-8 py-3 md:px-10 md:py-3.5 bg-primary-500 text-background-50 font-semibold text-sm md:text-base rounded-full hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              探索产品
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3 md:px-10 md:py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/25 text-background-50 font-semibold text-sm md:text-base rounded-full hover:bg-background-50/20 transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              了解品牌
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/30 rounded-full flex items-start justify-center p-1.5 animate-bounce">
          <div className="w-1 h-2 bg-background-50/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}